let e, n;
const o = (t) => {
  n = t;
}, r = () => e, u = () => n, g = (t) => {
  e = t.toLowerCase();
};
export {
  r as getCountry,
  u as getLanguage,
  g as setCountry,
  o as setLanguage
};
